import infrastructure from './infrastructure'
import advantages from './advantages'
export default {
  dictionaries: {
    namespaced: true,
    modules: {
      infrastructure,
      advantages
    }
  }
}
